import React, { useEffect } from "react";
import "./index.m.css";
import { SUBSCRIBE_PAGE_TEXT } from "../../../../constants";
import Whatsapp from "../../../atoms/social-media-icons/Whatsapp";
import Mail from "../../../atoms/social-media-icons/Mail";
import { isSubscriptionActive } from "../utils/subscription-state";
import { SpinnerIcon } from "../onboard-modal/icons";

export const DowngradeModal = ({ onClose, onConfirm, isLoading, userSubscriptions }) => {
  const active = userSubscriptions.find(isSubscriptionActive);
  const endDate = active ? new Date(active.end_timestamp).toLocaleDateString("kn-IN", { day: "numeric", month: "long", year: "numeric" }) : "";
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <div styleName="overlay" onClick={onClose}>
      <div styleName="popupContainer" onClick={(e) => e.stopPropagation()}>
        <h2 styleName="title">ಯೋಜನೆ ಬದಲಾವಣೆ ಕೋರಿಕೆ ಸಲ್ಲಿಕೆಯಾಗಿದೆ</h2>

        <p styleName="message">ಯೋಜನೆ ಬದಲಾವಣೆಯ ನಿಮ್ಮ ಕೋರಿಕೆ ದಾಖಲಾಗಿದೆ. ನಮ್ಮ ನಿಯಮಗಳ ಪ್ರಕಾರ ನಿಮ್ಮ ಹಾಲಿ ಯೋಜನೆಯ ಅವಧಿ ಮುಕ್ತಾಯದ ನಂತರವೇ ಯೋಜನೆ ಬದಲಾವಣೆ ಸಾಧ್ಯ. ನಿಮ್ಮ ಹಾಲಿ ಯೋಜನೆಯು {endDate} ವರೆಗೂ ಸಕ್ರಿಯವಾಗಿರಲಿದೆ.</p>

        <p styleName="message">ಹೆಚ್ಚಿನ ಮಾಹಿತಿ ಬೇಕಿದ್ದಲ್ಲಿ ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಬಹುದು</p>

        <div styleName="contactsWrapper">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              window.open("https://api.whatsapp.com/send/?phone=919035267304&text=Hi%2C%20I%20need%20assistance%20with%20my%20Prajavani%20Premium%20Subscription.%20Could%20you%20please%20help%20me%3F&type=phone_number&app_absent=0", "_blank", "noopener,noreferrer");
            }}
            styleName="whatsappButton"
          >
            <Whatsapp width={18} height={18} color="#25D366" />
            <span styleName="whatsappText">+91 9035267304</span>
          </a>

          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              window.open("https://mail.google.com/mail/u/0/?fs=1&to=support@prajavani.net&su=Support+Required+for+PV+subscription&body=Hi%2C+I+need+assistance+with+my+Prajavani+Premium+Subscription.+Could+you+please+help+me%3F&tf=cm", "_blank", "noopener,noreferrer");
            }}
            styleName="mailButton"
          >
            <Mail width={16} height={12} color="#000" />
            <span styleName="mailText">support@prajavani.net</span>
          </a>

          <div>
            <p styleName="workingHoursLabel">ಕೆಲಸದ ಸಮಯ</p>
            <p styleName="workingHoursTime">ಸೋಮವಾರದಿಂದ ಶುಕ್ರವಾರ: ಬೆಳಿಗ್ಗೆ 10 ರಿಂದ ಸಂಜೆ 6</p>
          </div>
        </div>

        <button styleName="actionButton" onClick={onConfirm} disabled={isLoading}>
          {isLoading ? <SpinnerIcon styleName="spinner" /> : SUBSCRIBE_PAGE_TEXT.DOWNGRADE_POPUP_BTN}
        </button>
      </div>
    </div>
  );
};
